module.exports = __webpack_public_path__ + "img/404.ac1dbf8a.png";